var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(-48 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M10.857.835A.835.835,0,0,1,11.692,0a8.356,8.356,0,0,1,8.347,8.347.835.835,0,0,1-1.669,0,6.685,6.685,0,0,0-6.678-6.678.835.835,0,0,1-.835-.835Zm.835,4.174a3.339,3.339,0,0,1,3.339,3.339.835.835,0,0,0,1.669,0,5.013,5.013,0,0,0-5.008-5.008.835.835,0,0,0,0,1.669Zm7.59,8.964a2.587,2.587,0,0,1,0,3.654l-.76.876C11.686,25.047-4.949,8.415,1.495,1.557l.96-.835A2.572,2.572,0,0,1,6.066.756c.026.026,1.573,2.035,1.573,2.035a2.588,2.588,0,0,1-.006,3.574L6.666,7.581a10.669,10.669,0,0,0,5.785,5.8l1.223-.972a2.588,2.588,0,0,1,3.573-.005S19.256,13.946,19.282,13.972Zm-1.149,1.214s-2-1.537-2.023-1.563a.918.918,0,0,0-1.293,0c-.023.023-1.706,1.365-1.706,1.365a.835.835,0,0,1-.817.127A12.528,12.528,0,0,1,4.931,7.763a.835.835,0,0,1,.121-.835S6.393,5.243,6.416,5.222a.918.918,0,0,0,0-1.293C6.39,3.9,4.853,1.9,4.853,1.9a.918.918,0,0,0-1.26.033l-.96.835C-2.076,8.435,12.34,22.051,17.3,17.362l.76-.876a.936.936,0,0,0,.071-1.3Z",
    transform: "translate(49.961 2.002)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.887f0eb33f64bc6cb2bc209f8c00e1e9.svg";
export { ForwardRef as ReactComponent };